module.exports = __webpack_public_path__ + "static/media/hands_blue1.9b415b43.jpg";